import { useTranslation } from 'react-i18next';

import { cardSurface } from '@/components/atoms/Card';
import type { StoredExtra } from '@/domain/providerConfig';

import extra from './StoredExtrasList.module.scss';

export interface StoredExtrasListProps {
    entries: readonly StoredExtra[];
}

/**
 * Stored values no field shows, each by its full path with its JSON, read-only. A value the
 * server withholds from a client admin reads "Set by OptoScale".
 */
function StoredExtrasList({ entries }: StoredExtrasListProps) {
    const { t } = useTranslation();
    return (
        <ul className={extra.extraEntries}>
            {entries.map((entry) => (
                <li key={entry.path} className={extra.extraEntry}>
                    <code className={extra.extraPath}>{entry.path}</code>
                    {entry.value === null ? (
                        <span className={extra.hidden}>
                            {t('providerConfig.storedExtraHidden')}
                        </span>
                    ) : (
                        <pre
                            {...cardSurface(
                                { variant: 'subtle', radius: 'sm', padding: 'none' },
                                extra.json
                            )}>
                            {entry.value}
                        </pre>
                    )}
                </li>
            ))}
        </ul>
    );
}

export default StoredExtrasList;
export { StoredExtrasList };
